import { ConfigService } from "./config.service";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ExchangeRateData } from "./../base-models/exchange-rate-data";
import { switchMap, map } from "rxjs/operators";
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ExchangeRateDataService {
    constructor(
        protected configService: ConfigService,
        protected httpClient: HttpClient
    ){
    }

    GetByCurrency(code : number, dateFrom : string, dateTo : string, exchangeRateListTypeID : number){
        return this.configService.GetCompanyDataServiceUrlAsync()
            .pipe(switchMap(config => {
                return this.httpClient
                    .get(config + 'api/ExchangeRateData/GetByCurrency?code=' + code + '&dateFrom=' + dateFrom +'&dateTo=' + dateTo + '&type=' + exchangeRateListTypeID)
                        .pipe(map((data: ExchangeRateData[]) => {
                            const items: ExchangeRateData[] = data ? data.map(item => {
                                return (new ExchangeRateData().Deserialize(item));
                            }) : [];
                            return items;
                        })
                    )
            }))
    }

    GetByDate(date : string, exchangeRateListTypeID : number){
        return this.configService.GetCompanyDataServiceUrlAsync()
            .pipe(switchMap(config => {
                return this.httpClient
                    .get(config + 'api/ExchangeRateData/GetByDate?date=' + date + '&type=' + exchangeRateListTypeID)
                        .pipe(map((data: ExchangeRateData[]) => {
                            const items: ExchangeRateData[] = data ? data.map(item => {
                                return (new ExchangeRateData().Deserialize(item));
                            }) : [];
                            return items;
                        })
                    )
            }))
    }
}